import { FeatureFlagKey } from '~/app/conf/feature-flag-config'
import { FeatureFlagService } from './feature-flag-service'
import { useBaseFeatureFlag } from './use-base-feature-flag'

export const useFeatureFlag = (): FeatureFlagService<FeatureFlagKey> => {
  return useBaseFeatureFlag<FeatureFlagKey>()
}
